import { Component } from '@angular/core';

@Component({
  selector: 'app-header-logo',
  templateUrl: './header-logo.component.html',
  styleUrls: ['./header-logo.component.scss'],
  standalone: false
})
export class HeaderLogoComponent {
  brillLink: string = "https://brill.com";
  brillLogoPath: string = "assets/images/brill_logo.gif";

  constructor() { }

  openPopup(): void {
    window.open(this.brillLink, '_blank', 'width=600,height=400,scrollbars=yes,resizable=yes')
  }
}